import type { MockupAnahtari } from '../../icerik/tipler'
import {
  SahneAidat,
  SahneAkademi,
  SahneBagis,
  SahneGuvenlik,
  SahneIletisim,
  SahneKongre,
  SahneKurullar,
  SahneMagaza,
  SahneMuhasebe,
  SahneOzet,
  SahnePortal,
  SahneUyeler,
  SahneWebSitesi,
} from './sahneler'

const SAHNELER: Record<MockupAnahtari, () => React.JSX.Element> = {
  ozet: SahneOzet,
  uyeler: SahneUyeler,
  aidat: SahneAidat,
  'web-sitesi': SahneWebSitesi,
  iletisim: SahneIletisim,
  portal: SahnePortal,
  kurullar: SahneKurullar,
  muhasebe: SahneMuhasebe,
  bagis: SahneBagis,
  kongre: SahneKongre,
  akademi: SahneAkademi,
  magaza: SahneMagaza,
  guvenlik: SahneGuvenlik,
}

export function Mockup({ anahtar }: { anahtar: MockupAnahtari }) {
  const Sahne = SAHNELER[anahtar]
  return <Sahne />
}

export { Tarayici, Telefon } from './cerceve'
